import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLocale } from 'core/store/selectors/getLocale';
import { parseGradesToScoreScale, parseGradesToStandardScale } from 'core/utils/parses';
import { EMPTY_VALUE_INDICATOR, formatDisplayValue, useLocalizedInput } from 'core/utils/numericInputUtils';

export default function useInputGrades({ ariaLabel, props, max, onChange, pointsTotal, scoreScale, t }) {
  const locale = useSelector(getLocale);
  const scaleMax = parseGradesToScoreScale(10, scoreScale);
  const effectiveMax = Number.isFinite(max) ? max : scaleMax;

  const { value, setValue, hasError, setHasError, onChangeText, onFocus, onBlur } = useLocalizedInput({
    initialValue: formatDisplayValue(parseGradesToScoreScale(props.value, scoreScale), locale),
    initialHasError: props.value > effectiveMax,
    locale,
    max: effectiveMax,
    onChange,
    transformBeforeEmit: (parsed) => parseGradesToStandardScale(parsed, scoreScale),
    extraValidation: scoreScale === '1-5' ? (parsed) => parsed >= 1 : undefined,
  });

  useEffect(() => {
    const scaled = parseGradesToScoreScale(props.value, scoreScale);
    if (scaled == null || scaled === EMPTY_VALUE_INDICATOR) {
      setHasError(false);
      return;
    }
    setValue(formatDisplayValue(scaled, locale));
    const num = Number(scaled);
    setHasError(Number.isFinite(num) && num > effectiveMax);
  }, [props.value, max, scoreScale, locale]);

  // `t` llega por props y el catálogo de átomos (UiViewAtoms) no la pasa
  const accessibleName = ariaLabel || t?.('grades:Score out of total', { total: pointsTotal });

  return { accessibleName, value, hasError, onChangeText, onFocus, onBlur };
}
